
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { Guide } from "@/types/guides";

export function useGuideUpload() {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  const uploadGuide = async (file: File, guide: Guide) => {
    try {
      setIsUploading(true);
      setUploadError(null);

      // Upload file to Supabase storage
      const fileExt = file.name.split('.').pop();
      const fileName = `${guide.slug}.${fileExt}`;
      const filePath = `${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('guides')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: true
        });

      if (uploadError) {
        setUploadError(uploadError.message);
        return null;
      }

      // Get the public URL
      const { data: { publicUrl } } = supabase.storage
        .from('guides')
        .getPublicUrl(filePath);

      // Update the guide in the database with the new download URL
      const { error: updateError } = await supabase
        .from('guides')
        .update({ download_url: publicUrl })
        .eq('id', guide.id);

      if (updateError) {
        setUploadError(updateError.message);
        return null;
      }

      return publicUrl;
    } catch (err) {
      setUploadError(err instanceof Error ? err.message : 'Upload failed');
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadGuide, isUploading, uploadError };
}
